webpackJsonp([61],{

/***/ 1284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clerkinn_guest_modal_history_guest__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clerkinn_guest_modal_history_guest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__clerkinn_guest_modal_history_guest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_helper__ = __webpack_require__(59);




var printGuest = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var baseUrl, customerId, dateStart, dateEnd, name, responseType, cardModel, response, blob;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						baseUrl = '//pms.controlinn.com/api' + '/report/customerBooking';
						customerId = this.paramsBookingHistory.idCustomer;
						dateStart = this.startDate;
						dateEnd = this.endDate;
						name = 'Reporte Historial del Huesped';
						responseType = 'blob';
						cardModel = { rows: [{}] };
						_context.next = 9;
						return this.$http.post(baseUrl + '?customerId=' + customerId + '&dateStart=' + dateStart + '&dateEnd=' + dateEnd, cardModel, { responseType: responseType });

					case 9:
						response = _context.sent;
						blob = helperMethods.generateBlob(response.bodyBlob);

						helperMethods.showDownloadDialog(blob, name, 'pdf');

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function printGuest() {
		return _ref.apply(this, arguments);
	};
}();

var loadBookingHistory = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						this.paramsBookingHistory.page = page;
						this.paramsBookingHistory.idCustomer = this.$route.query.customerId;
						_context2.next = 4;
						return this.$http.get('//pms.controlinn.com/api' + '/customer/bookings', { params: this.paramsBookingHistory });

					case 4:
						response = _context2.sent;

						this.totalHistoryPages = response.data.meta.pagination.total_pages;
						this.isLoading = true;
						this.rows = response.data.data.map(function (row) {
							var newRow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, row);
							if (row.summary && row.summary.booking) {
								newRow.guests = row.summary.booking.adults + row.summary.booking.childrens;
							}
							return newRow;
						});

					case 8:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadBookingHistory() {
		return _ref4.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var helperMethods = __WEBPACK_IMPORTED_MODULE_6__shared_helper__["a" /* default */].methods;

function closeModal() {
	this.visibleModal = false;
}

function goToEdit(action) {
	var editHref = {
		name: 'detail-guest',
		query: { codeBooking: action.code }
	};
	this.$router.push(editHref);
}

function returnGuest() {
	var editHref = { name: 'guest' };
	this.$router.push(editHref);
}
function searchByColumn(search) {
	this.paramsBookingHistory.search = search;
	this.loadBookingHistory();
}

function columnSortableEvent(_ref2) {
	var id = _ref2.id;

	var self = this;
	var newColumn = self.columns.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map(function (columnSingle) {
		var newColumnSingle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, columnSingle);
		if (columnSingle.isSortable) {
			if (columnSingle.id !== newColumn[0].id) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
		}
		return newColumnSingle;
	});
	this.paramsBookingHistory.sortField = newColumn[0].code;
	this.paramsBookingHistory.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.loadBookingHistory();
}

function created() {
	this.loadBookingHistory();
}

function customButton(_ref3) {
	var btn = _ref3.btn,
	    row = _ref3.row;

	if (btn.id === 3) {
		this.modalHistory = row;
		this.visibleModal = true;
	}
}

function pagesVisibleHistory() {
	if (this.totalHistoryPages >= 1 && this.totalHistoryPages < 5) {
		return this.totalHistoryPages;
	}
	return 5;
}

function filterBookings() {
	this.paramsBookingHistory.dateInit = this.startDate;
	this.paramsBookingHistory.dateEnd = this.endDate;
	this.loadBookingHistory();
}

function arrowIconEnd() {
	var arrowEnd = this.onChangeEnd ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrowEnd;
}

function toggleIconEndDate() {
	this.onChangeEnd = !this.endDate;
}

function changeEndIcon(result) {
	this.onChangeEnd = result;
}

function arrowIconStart() {
	var arrowStart = this.onChangeStart ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrowStart;
}

function toggleIconStartDate() {
	this.onChangeStart = !this.startDate;
}

function changeIconStart(result) {
	this.onChangeStart = result;
}

function data() {
	return {
		customerId: 0,
		id: null,
		visibleModal: false,
		modalHistory: {},
		isLoading: false,
		totalHistoryPages: 5,
		paramsBookingHistory: {
			page: 1,
			perPage: 10,
			idCustomer: null
		},
		optionButtons: [{
			id: 3,
			icon: 'remove_red_eye',
			code: 'remove_red_eye'
		}],
		columns: [{ id: 1, name: '#Reserva', code: 'number' }, { id: 2, name: 'Fecha de Reserva', code: 'date-reservation' }, { id: 3, name: 'Habitación', code: 'room' }, { id: 4, name: 'Check In', code: 'check-in' }, { id: 5, name: 'Check Out', code: 'check-out' }, { id: 6, name: 'Gasto Total', code: 'total-cost' }, { id: 7, name: 'Gasto por Consumo', code: 'total-consum' }],
		rows: [],
		paramsBookin: {
			page: 1,
			perPage: 10,
			idCustomer: null
		},
		startDate: '',
		menu: false,
		menuEnd: false,
		onChangeEnd: false,
		onChangeStart: false,
		endDate: ''
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'history-guest',
	data: data,
	created: created,
	components: {
		tableRun: __WEBPACK_IMPORTED_MODULE_3_table_run___default.a,
		modalHistoryGuest: __WEBPACK_IMPORTED_MODULE_5__clerkinn_guest_modal_history_guest___default.a
	},
	methods: {
		printGuest: printGuest,
		closeModal: closeModal,
		goToEdit: goToEdit,
		returnGuest: returnGuest,
		searchByColumn: searchByColumn,
		customButton: customButton,
		columnSortableEvent: columnSortableEvent,
		loadBookingHistory: loadBookingHistory,
		filterBookings: filterBookings,
		changeEndIcon: changeEndIcon,
		changeIconStart: changeIconStart,
		toggleIconStartDate: toggleIconStartDate,
		toggleIconEndDate: toggleIconEndDate
	},
	computed: {
		pagesVisibleHistory: pagesVisibleHistory,
		arrowIconEnd: arrowIconEnd,
		arrowIconStart: arrowIconStart
	},
	mixins: __WEBPACK_IMPORTED_MODULE_4__shared_mixins__["a" /* default */]
});

/***/ }),

/***/ 1286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_mixins__ = __webpack_require__(56);



var loadModalHistory = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var baseUrl, _ref2, billing;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						baseUrl = '//pms.controlinn.com/api';
						_context.next = 4;
						return this.$http.get(baseUrl + '/details-accounts/' + this.bookingCode + '/payments');

					case 4:
						_ref2 = _context.sent;
						billing = _ref2.data;

						this.billingDetail = billing.data;
						this.currencySelected = billing.data.currency || billing.data.saleDocument.currency;
						_context.next = 13;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context['catch'](0);

						this.showNotification('No se encontraron documentos', 'info');

					case 13:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 10]]);
	}));

	return function loadModalHistory() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.loadModalHistory();
}

function closeModal() {
	this.$emit('close');
}

function data() {
	return {
		currencySelected: '',
		rows: [],
		billingDetail: {},
		columns: [{ id: 1, name: '# Comprobante' }, { id: 2, name: 'Fecha' }, { id: 3, name: 'Hora' }, { id: 4, name: 'Producto' }, { id: 5, name: 'Gasto' }]
	};
}
/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'modal-guest',
	data: data,
	created: created,
	mixins: __WEBPACK_IMPORTED_MODULE_3__shared_mixins__["a" /* default */],
	components: {
		tableRun: __WEBPACK_IMPORTED_MODULE_2_table_run___default.a
	},
	methods: {
		closeModal: closeModal,
		loadModalHistory: loadModalHistory
	},
	props: {
		bookingCode: String
	}
});

/***/ }),

/***/ 1395:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".background-modal-guest[data-v-3e92b557]{background-color:#fff;padding:15px}.container-modal[data-v-3e92b557]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.modal-history-guest[data-v-3e92b557]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:rgba(0,0,0,.42);bottom:0;content:\"\";display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;left:0;position:fixed;right:0;top:0;width:100%;z-index:10}.section-history-guest[data-v-3e92b557]{width:645px;height:42px;background-color:#fff}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/guest/modal-history-guest.vue"],"names":[],"mappings":"AACA,yCACE,sBAAwB,AACxB,YAAc,CACf,AACD,kCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,sCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,2BAAgC,AAChC,SAAU,AACV,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,OAAQ,AACR,eAAgB,AAChB,QAAS,AACT,MAAO,AACP,WAAY,AACZ,UAAY,CACb,AACD,wCACE,YAAa,AACb,YAAa,AACb,qBAAwB,CACzB","file":"modal-history-guest.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.background-modal-guest[data-v-3e92b557] {\n  background-color: white;\n  padding: 15px;\n}\n.container-modal[data-v-3e92b557] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.modal-history-guest[data-v-3e92b557] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: rgba(0, 0, 0, 0.42);\n  bottom: 0;\n  content: '';\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 10;\n}\n.section-history-guest[data-v-3e92b557] {\n  width: 645px;\n  height: 42px;\n  background-color: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1480:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1395);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("7a826113", content, true);

/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1480)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1286),
  /* template */
  __webpack_require__(1625),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e92b557",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1625:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-history-guest"
  }, [_c('div', {
    staticClass: "background-modal-guest"
  }, [_c('div', {
    staticClass: "container-modal"
  }, [_c('div', {
    staticClass: "section-history-guest"
  }, [_c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "selectable": false,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-search": false,
      "include-switch": false,
      "include-settings": true,
      "include-delete-single": false,
      "columns": _vm.columns,
      "rows": _vm.rows
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.hour))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.product))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.gast))])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "mt-5": "",
      "align-right": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-cancel green",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n\t\t\t\t\tCerrar\n\t\t\t\t\t\t")])], 1)], 1)], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1660:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "title-form"
  }, [_vm._v("Filtro")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": "",
      "my-1": ""
    }
  }, [_c('v-layout', {
    staticClass: "calendar-range",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "250px"
    },
    on: {
      "input": _vm.changeIconStart
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    staticClass: "product-date-picker",
    attrs: {
      "label": "Fecha inicial",
      "prepend-icon": "event",
      "append-icon": _vm.arrowIconStart,
      "append-icon-cb": _vm.toggleIconStartDate,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    on: {
      "input": _vm.changeEndIcon
    },
    model: {
      value: (_vm.menuEnd),
      callback: function($$v) {
        _vm.menuEnd = $$v
      },
      expression: "menuEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha final",
      "append-icon": _vm.arrowIconEnd,
      "append-icon-cb": _vm.toggleIconEndDate,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": "",
      "pr5": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-success white--text",
    attrs: {
      "type": "button",
      "disabled": !_vm.startDate || !_vm.endDate
    },
    on: {
      "click": _vm.filterBookings
    }
  }, [_c('v-icon', [_vm._v("filter_list")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "mt-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-success white--text",
    on: {
      "click": _vm.printGuest
    }
  }, [_c('v-icon', [_vm._v("print")]), _vm._v("\n\t\t\t\t\tImprimir Listado\n\t\t\t\t")], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt5": ""
    }
  }, [_c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "selectable": false,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-switch": false,
      "include-settings": true,
      "include-delete-single": false,
      "columns": _vm.columns,
      "option-buttons": _vm.optionButtons,
      "rows": _vm.rows
    },
    on: {
      "custom-button": _vm.customButton,
      "on-search-event": _vm.searchByColumn,
      "go-to-edit-page": _vm.goToEdit,
      "on-sortable-event": _vm.columnSortableEvent
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.numReservation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.bookingStart))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t" + _vm._s(props.row.codeRoomtype) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.bookingStart))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.bookingEnd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.totalConsumptions))])]
      }
    }])
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalHistoryPages,
      "total-visible": _vm.pagesVisibleHistory
    },
    on: {
      "input": function($event) {
        _vm.loadBookingHistory(_vm.paramsBookingHistory.page)
      }
    },
    model: {
      value: (_vm.paramsBookingHistory.page),
      callback: function($$v) {
        _vm.paramsBookingHistory.page = $$v
      },
      expression: "paramsBookingHistory.page"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-success white--text",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.returnGuest
    }
  }, [_vm._v("\n\t\t\t\tVolver\n\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), (_vm.visibleModal) ? _c('modal-history-guest', {
    attrs: {
      "booking-code": _vm.modalHistory.code
    },
    on: {
      "close": _vm.closeModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1284),
  /* template */
  __webpack_require__(1660),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/61.dedceddc397a364b4b3d.js